<template>
    <a-spin :spinning="spinning" tip="Loading...">
        <div class="card mb-3">
            <div class="row no-gutters">
                <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                    <div class="card-body">

                        <div class="row">
                            <div class="col-md-4">
                                <base-input alternative="" label="Date Range"><br>
                                    <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM-DD-YYYY hh:mm A" :placeholder="['Start Date', 'End Date']" style="width:100%"/>
                                </base-input>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <base-input alternative="" label="Select Site">
                                    <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption">
                                        <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                    </a-select>
                                </base-input>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <base-input alternative="" label="Customer Name">
                                    <a-select
                                        show-search
                                        v-model="inputCustomerName"
                                        placeholder="Search customer..."
                                        style="width: 100%"
                                        :filter-option="false"
                                        @search="searchCustomers"
                                        :not-found-content="customerSearching ? undefined : null"
                                    >
                                        <a-spin v-if="customerSearching" slot="notFoundContent" size="small" />
                                        <a-select-option v-for="customer in customerOptions" :key="customer.name" :value="customer.name">
                                            {{customer.name}}
                                        </a-select-option>
                                    </a-select>
                                </base-input>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <base-input label="Transactions">
                                    <select class="form-control" v-model="inputTransactions">
                                        <option v-for="option in transactionOptions" :value="option.key" :key="option.key">
                                            {{ option.value }}
                                        </option>
                                    </select>
                                </base-input>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <br>
                                <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                                <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;

                                <button v-if="JsonData.length > 0" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="downloadCsv"> Download CSV </button> &nbsp; &nbsp;
                                <button v-if="JsonData.length > 0" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateExcel"> Download Excel </button> &nbsp; &nbsp;
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import reportUtils from '../../components/reportUtils'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import * as ExcelJS from "exceljs";
    import _ from 'lodash';

    import {
        mapState,
        mapActions
    } from 'vuex'

    var component_x;

    export default {
        components: {
        },
        props: ['access_rights'],
        data() {
            return {
                spinning: false,
                inputDate: [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
                inputCustomerName: undefined,
                inputTransactions: 'All',
                inputSite: [],
                siteOptions: [],
                customerOptions: [],
                customerSearching: false,
                transactionOptions: [
                    {key: 'All', value: 'All'},
                    {key: 'Earn', value: 'Earn'},
                    {key: 'Redeem', value: 'Redeem'},
                    {key: 'Adjustment', value: 'Adjustment'},
                ],
                currDate: moment().format("L_LT").split(":").join(";"),
                JsonData: []
            }
        },
        mounted: async function () {
            component_x = this;
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?mode=all&site_type=branch", null);
            component_x.siteOptions = sites;
            component_x.siteOptions.sort((a, b) => a.name.localeCompare(b.name));
        },
        computed: {
            ...mapState(['currentProfile', 'endPoint']),
        },
        methods: {
            moment,
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            searchCustomers: _.debounce(async function(value) {
                if (!value || value.length < 2) {
                    this.customerOptions = [];
                    return;
                }
                this.customerSearching = true;
                try {
                    var customers = await HTTPRequest.getRequest(this.endPoint + "customers?name=" + encodeURIComponent(value) + "&status=A&per_page=20&page=1", null);
                    this.customerOptions = customers.data || customers || [];
                } catch (e) {
                    this.customerOptions = [];
                }
                this.customerSearching = false;
            }, 400),
            convertToCurrency(num) {
                return Number(num).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            generateReport: async function () {
                if (!this.inputCustomerName) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Please select a customer.');
                    return;
                }
                if (!this.inputDate || this.inputDate.length === 0) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Please select a date range.');
                    return;
                }

                this.spinning = true;
                try {
                let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');
                let from_header = this.inputDate[0].format('MMMM DD, YYYY');
                let to_header = this.inputDate[1].format('MMMM DD, YYYY');

                let parameters = {
                    "customer_name": this.inputCustomerName,
                    "transactions": this.inputTransactions,
                    "date_from": from_date,
                    "date_to": to_date,
                    "site_id": this.inputSite.toString()
                }

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'clp_transaction_history_report?', parameters);

                if (get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                    return;
                }

                if (get_request.length > 0) {
                    var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });

                    let reportLogo = document.getElementById('reportLogo');
                    try {
                        if (reportLogo && reportLogo.naturalWidth > 0) {
                            doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);
                        }
                    } catch (e) {
                        console.warn('Could not add report logo to PDF:', e);
                    }

                    let headers = [
                        [
                            {content: 'Customer Name', styles: {halign: 'center'}},
                            {content: 'Site Name', styles: {halign: 'center'}},
                            {content: 'Terminal Name', styles: {halign: 'center'}},
                            {content: 'Transaction Number', styles: {halign: 'center'}},
                            {content: 'Business Date', styles: {halign: 'center'}},
                            {content: 'Transaction', styles: {halign: 'center'}},
                            {content: 'Purchase Amount', styles: {halign: 'center'}},
                            {content: 'Points', styles: {halign: 'center'}},
                        ]
                    ];

                    let filter_header = `Customer: ${this.inputCustomerName} | Transactions: ${this.inputTransactions}`;

                    for (let x = 0; x < get_request.length; x++) {
                        let reportDetails = get_request[x].report_details;

                        if (x > 0 && reportDetails.length > 0) {
                            doc.addPage();
                        }

                        let reportData = [];
                        if (reportDetails.length > 0) {
                            for (let i = 0; i < reportDetails.length; i++) {
                                let line = reportDetails[i];
                                reportData.push([
                                    line.customer_name,
                                    line.site_name,
                                    line.terminal_name,
                                    line.transaction_number,
                                    line.business_date,
                                    line.transaction,
                                    this.convertToCurrency(Number(line.purchase_amount || 0)),
                                    Number(line.points || 0).toFixed(2)
                                ]);
                            }
                        }

                        let design_x = 330;
                        let design_y = 200;

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15, 20, "CLP Transaction History Report");
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        doc.text(15, 25, "For the Period of " + from_header + " to " + to_header);
                        doc.text(15, 30, filter_header);

                        doc.autoTable({
                            startY: 40,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'auto',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            margin: { bottom: 30 },
                            styles: {
                                cellPadding: 1.3, fontSize: 10,
                            },
                            columnStyles: {
                                0: {cellWidth: 'auto', halign: 'left'},
                                1: {cellWidth: 'auto', halign: 'left'},
                                2: {cellWidth: 'auto', halign: 'left'},
                                3: {cellWidth: 'auto', halign: 'center'},
                                4: {cellWidth: 'auto', halign: 'center'},
                                5: {cellWidth: 'auto', halign: 'center'},
                                6: {cellWidth: 'auto', halign: 'right'},
                                7: {cellWidth: 'auto', halign: 'right'},
                            }
                        });
                    }

                    let printed_by = secureStorage.getItem("email") || '';
                    let pageCount = doc.internal.getNumberOfPages();
                    for (let i = 1; i <= pageCount; i++) {
                        doc.setPage(i);
                        reportUtils.pdfTools.addFooter(doc, printed_by, "CLP Transaction History Report", 330, 200, i, pageCount);
                    }
                    doc.save(`CLPTransactionHistoryReport_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'warning', 'No data found. Try adjusting the filters.');
                }
                } catch (e) {
                    console.error('Generate PDF error:', e);
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Error generating report: ' + e.message);
                } finally {
                    this.spinning = false;
                }
            },
            generateFile: async function () {
                if (!this.inputCustomerName) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Please select a customer.');
                    return;
                }
                if (!this.inputDate || this.inputDate.length === 0) {
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Please select a date range.');
                    return;
                }

                this.spinning = true;
                try {
                    let from_date = this.inputDate[0].format('YYYY-MM-DD HH:mm:ss');
                    let to_date = this.inputDate[1].format('YYYY-MM-DD HH:mm:ss');

                    let parameters = {
                        "customer_name": this.inputCustomerName,
                        "transactions": this.inputTransactions,
                        "date_from": from_date,
                        "date_to": to_date,
                        "site_id": this.inputSite.toString()
                    }

                    var get_request = await HTTPRequest.getRequest(this.endPoint + 'clp_transaction_history_report?', parameters);

                    if (get_request.error) {
                        reportUtils.openNotificationWithIcon(component_x, 'error', get_request.error);
                        return;
                    }

                    if (get_request.length > 0) {
                        let headers = ["Customer Name", "Site Name", "Terminal Name", "Transaction Number", "Business Date", "Transaction", "Purchase Amount", "Points"];
                        let site_specific = [];

                        for (let x = 0; x < get_request.length; x++) {
                            let reportDetails = get_request[x].report_details;
                            let reportData = [];

                            if (reportDetails.length > 0) {
                                for (let i = 0; i < reportDetails.length; i++) {
                                    let line = reportDetails[i];
                                    reportData.push([
                                        line.customer_name,
                                        line.site_name,
                                        line.terminal_name,
                                        line.transaction_number,
                                        line.business_date,
                                        line.transaction,
                                        line.purchase_amount,
                                        line.points
                                    ]);
                                }
                            }

                            let keys = headers;
                            let values = reportData;
                            let newJsonData = [];

                            for (var i = 0; i < values.length; i++) {
                                var result = Object.assign.apply({}, keys.map((val, index) => ({
                                    [val]: values[i][index]
                                })));
                                newJsonData.push(result);
                            }

                            newJsonData.forEach(function(obj) {
                                for (var i in obj) {
                                    if (obj[i] === undefined || obj[i] === null) {
                                        obj[i] = '';
                                    }
                                }
                            });
                            site_specific.push(newJsonData);
                        }
                        this.JsonData = site_specific.flat(Infinity);
                    } else {
                        reportUtils.openNotificationWithIcon(component_x, 'warning', 'No data found.');
                    }
                } catch (e) {
                    console.error('Generate file error:', e);
                    reportUtils.openNotificationWithIcon(component_x, 'error', 'Error: ' + e.message);
                } finally {
                    this.spinning = false;
                }
            },
            downloadCsv() {
                if (this.JsonData.length === 0) return;
                const headers = Object.keys(this.JsonData[0]);
                const csvRows = [headers.join(',')];
                this.JsonData.forEach(row => {
                    const values = headers.map(h => {
                        const val = (row[h] === null || row[h] === undefined) ? '' : row[h];
                        return `"${String(val).replace(/"/g, '""')}"`;
                    });
                    csvRows.push(values.join(','));
                });
                const csvContent = csvRows.join('\n');
                const encodedUri = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvContent);
                const link = document.createElement('a');
                link.setAttribute('href', encodedUri);
                link.setAttribute('download', `CLP-Transaction-History-${moment().format('YYYYMMDD_HHmmss')}.csv`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.JsonData = [];
            },
            async generateExcel() {
                const workbook = new ExcelJS.Workbook();
                workbook.created = new Date();
                workbook.modified = new Date();
                const sheet = workbook.addWorksheet("CLP Transaction History", {
                    pageSetup: { paperSize: 9 }
                });

                let from_header = this.inputDate[0].format('MMMM DD, YYYY');
                let to_header = this.inputDate[1].format('MMMM DD, YYYY');
                let filter_header = `Customer: ${this.inputCustomerName} | Transactions: ${this.inputTransactions}`;

                const data_starts_at_row = 7;

                let reportLogo = document.getElementById('reportLogo');
                const base64Image = reportUtils.csvxlsxTools.getBase64Image(reportLogo);
                const imageId = workbook.addImage({
                    base64: base64Image,
                    extension: 'png',
                });
                sheet.addImage(imageId, {
                    tl: { col: 0, row: 0 },
                    ext: { width: 61, height: 61 }
                });

                sheet.getRow(4).values = ['CLP Transaction History Report'];
                sheet.getRow(5).values = [`For the Period of ${from_header} to ${to_header}`];
                sheet.getRow(6).values = [`Filtered by: ${filter_header}`];

                sheet.getRow(data_starts_at_row).values = ["Customer Name", "Site Name", "Terminal Name", "Transaction Number", "Business Date", "Transaction", "Purchase Amount", "Points"];
                sheet.columns = [
                    { key: "customer_name", width: 25 },
                    { key: "site_name", width: 20 },
                    { key: "terminal_name", width: 20 },
                    { key: "transaction_number", width: 20 },
                    { key: "business_date", width: 15 },
                    { key: "transaction", width: 12 },
                    { key: "purchase_amount", width: 18 },
                    { key: "points", width: 12 },
                ];

                var report_details = this.JsonData;
                var rowDatas = [];

                for (let i = 0; i < report_details.length; i++) {
                    const rd = report_details[i];
                    rowDatas.push({
                        customer_name: rd["Customer Name"],
                        site_name: rd["Site Name"],
                        terminal_name: rd["Terminal Name"],
                        transaction_number: rd["Transaction Number"],
                        business_date: rd["Business Date"],
                        transaction: rd["Transaction"],
                        purchase_amount: rd["Purchase Amount"],
                        points: rd["Points"]
                    });
                }

                sheet.addRows(rowDatas);

                sheet.getRow(4).font = { bold: true, size: 16 };
                sheet.getRow(4).height = 20;
                sheet.getRow(data_starts_at_row).font = { bold: true };

                sheet.eachRow(function (Row, rowNum) {
                    if (rowNum >= data_starts_at_row) {
                        Row.eachCell(function (Cell, cellNum) {
                            if (rowNum == data_starts_at_row) {
                                Cell.alignment = { horizontal: 'center' };
                            } else {
                                Cell.alignment = { vertical: 'middle', horizontal: 'left' };
                            }
                        });
                    }
                });

                workbook.xlsx.writeBuffer().then(function(buffer) {
                    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                    const reader = new FileReader();
                    reader.onload = function() {
                        const link = document.createElement('a');
                        link.setAttribute('href', reader.result);
                        link.setAttribute('download', 'CLPTransactionHistoryReport.xlsx');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    };
                    reader.readAsDataURL(blob);
                });
                this.JsonData = [];
            }
        }
    };
</script>

<style></style>
